export default {
    methods: {
        portfolioPerformanceIndicators(value, target) {
            let performance = 0
            let progress = 0

            value = parseFloat(value)
            target = parseFloat(target)

            if (value !== 0.00 && target !== 0.00) {
                performance = value / target
                progress = _.round(performance.toFixed(2) * 100, -1)
            }

            performance = performance.toFixed(2)

            return {
                performance,
                progress: (progress > 100) ? 100 : progress,
            }
        },
    }
}
